export { default } from 'common/models/description';
